import { render } from "./profile-image.vue?vue&type=template&id=86c96ed4&ts=true"
import script from "./profile-image.vue?vue&type=script&lang=ts"
export * from "./profile-image.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__